var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallAttentionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8638 1.48076C14.4779 0.819257 13.5221 0.819259 13.1362 1.48076L0.877257 22.4961C0.488374 23.1628 0.969246 24 1.74104 24H26.259C27.0308 24 27.5116 23.1628 27.1227 22.4961L14.8638 1.48076ZM14.9333 9.23077V11.5385L14.4667 16.6154H13.5333L13.0667 11.5385V9.23077H14.9333ZM13.0667 20.3077V18.4615H14.9333V20.3077H13.0667Z",
    fill: "#CE8D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0667 9.23077H14.9333V11.5385L14.4667 16.6154H13.5333L13.0667 11.5385V9.23077Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0667 18.4615V20.3077H14.9333V18.4615H13.0667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallAttentionIcon);
export default __webpack_public_path__ + "static/media/smallAttentionIcon.bf60ebd806f77e2047ef72872a874d9f.svg";
export { ForwardRef as ReactComponent };